import { RequestForQuoteGatewayMessage } from '../../../../types/RequestForQuoteGatewayMessage';
import { useRole } from '../../../common/hooks/useRole';
import { Box } from '../../../common/ui/Box';
import { AgentParty } from '../../../offer/detail/common/components/InvolvedParties/AgentParty';
import { CustomerParty } from '../../../offer/detail/common/components/InvolvedParties/CustomerParty';
import { InvolvedPartyLayoutContext } from '../../../offer/detail/common/components/InvolvedParties/InvolvedParty';
import { SupplierParty } from '../../../offer/detail/common/components/InvolvedParties/SupplierParty';
import { VesselParty } from '../../../offer/detail/common/components/InvolvedParties/VesselParty';
import { OfferState } from '../../../offer/model/OfferState';

interface RfqInvolvedPartiesProps {
    rfq: RequestForQuoteGatewayMessage;
    layout?: 'horizontal' | 'vertical';
}

export const RfqInvolvedParties = ({ rfq, layout = 'horizontal' }: RfqInvolvedPartiesProps) => {
    const role = useRole();
    const isSpot = rfq.offers.some((offer) => offer.isSpot());
    const isEnquiry = [OfferState.ENQUIRY, OfferState.QUOTED].includes(rfq.state);

    return (
        <InvolvedPartyLayoutContext.Provider value={layout}>
            <Box
                display={layout === 'vertical' ? 'grid' : 'flex'}
                gridTemplateColumns={layout === 'vertical' ? 'min-content minmax(0, 1fr)' : undefined}
                columnGap={layout === 'vertical' ? 24 : 0}
                rowGap={layout === 'vertical' ? 16 : 0}
                alignContent={layout === 'vertical' ? 'start' : undefined}
                alignItems={layout === 'vertical' ? 'start' : undefined}
                width={layout === 'horizontal' ? '100%' : undefined}
            >
                <VesselParty vessel={rfq.vessel} />

                {role.isSuperAdmin() ? <SupplierParty supplier={rfq.supplier} /> : null}
                {role.isSupplier() || role.isSuperAdmin() ? (
                    <CustomerParty customer={rfq.customer} isSpot={isSpot} isEnquiry={isEnquiry} />
                ) : null}

                <AgentParty agent={rfq.agentInformation} />
            </Box>
        </InvolvedPartyLayoutContext.Provider>
    );
};
